// import { createHash } from 'crypto';

// export const createHashHex = (secret: string) => {
//   const hash = createHash('sha256');
//   hash.update(secret);
//   return hash.digest('hex');
// };

/**
 * Can't use 'crypto' since it's a Node module so here's a
 * browser version (Web Crypto API / SubtleCrypto)
 * copy paste from: https://blog.logto.io/migrate-to-web-crypto/
 *  */

export const createHashHex = async (secret: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(secret);
  const hash = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hash))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};
